module.exports = __webpack_public_path__ + "img/Real World Sharp Shooter Unlocked.d7eb1ce.png";